import { RefinePosition } from 'searchCards';
import { RefineClub } from 'searchCards/RefineClubs';
import { MatchInfoGroup, PlayerGroup } from 'searchCards/mlb/cardFilters';

const MAX_TEAM_LIMIT = 30;

export const scoutingCenterMarketFilters = [
  MatchInfoGroup(true),
  PlayerGroup({ withoutActiveClub: true }),
];

export const scoutingCenterMarketDropdownFilters = [
  RefinePosition(),
  RefineClub(MAX_TEAM_LIMIT),
];
